export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 20;
export const RES_PER_PAGE = 10;
export const KEY = "275c5b48-cbc8-4dd5-acb3-45ebe0e64f7a";
export const MODAL_CLOSE_SEC = 1.5;
